import { render, staticRenderFns } from "./solitaire.vue?vue&type=template&id=65c8f2f4&scoped=true"
import script from "./solitaire.vue?vue&type=script&lang=js"
export * from "./solitaire.vue?vue&type=script&lang=js"
import style0 from "./solitaire.vue?vue&type=style&index=0&id=65c8f2f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c8f2f4",
  null
  
)

export default component.exports